import { NotesModalComponentData } from '@modules/notes/components/modal/notes-modal.component';
import { createAction, props } from '@ngrx/store';
import { TeamMember } from '@shared';

import { Note } from 'mojo-irp-notes';

export enum NotesActionTypes {
  Load = '[Notes] Load',
  Create = '[Notes] Create',

  OpenModal = '[Notes] Open Notes Modal',
  OpenModalSuccess = '[Notes] Open Notes Modal Success',
  CloseModal = '[Notes] Close Notes Modal',
}

export const notesLoad = createAction(NotesActionTypes.Load);

export const notesCreate = createAction(NotesActionTypes.Create, props<{ payload: Note }>());

export const notesOpenModal = createAction(
  NotesActionTypes.OpenModal,
  props<{ data: NotesModalComponentData }>(),
);

export const notesOpenModalSuccess = createAction(
  NotesActionTypes.OpenModalSuccess,
  props<{ noteId?: number; teamMembers?: TeamMember[] }>(),
);

export const notesCloseModal = createAction(NotesActionTypes.CloseModal);
